import { gql } from 'graphql-request'

export const GET_TOP_HASHTAG_USED = gql`
  query FindTagUsed(
    $dateRange: DatePicker
    $limitPerPage: Int
    $page: Int
    $orderBy: UserTagUsedOrderBy
  ) {
    findTagUsed(
      dateRange: $dateRange
      limitPerPage: $limitPerPage
      page: $page
      orderBy: $orderBy
    ) {
      data {
        tagName
        totalTagUsed
      }
      page
    }
  }
`
